const sizes = {
  medium: 768,
  mlarge: 1050,
  large: 1280,
  xlarge: 1440,
};

export const deviceWidths = {
  giant: sizes.large,
  mlarge: sizes.mlarge,
  tablet: sizes.medium,
  phone: sizes.medium - 1,
};
